import { useLayoutEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch, RootState } from '@reducers/index';
import { fetchExploreInfoBox, fetchExploreGridBox } from '@reducers/keyword/thunk/exploreThunk';

import InfoBox from '@components/template/keyword/explorer/infoBox';
import ExplorerGridBox from '@components/template/keyword/explorer/explorerGridBox';

const Research = () => {
  const dispatch = useDispatch<AppDispatch>();

  useLayoutEffect(() => {
    dispatch(fetchExploreInfoBox({ userId: 'SS' }));
    dispatch(fetchExploreGridBox({ userId: 'SS' }));
  }, []);

  return (
    <>
      <InfoBox />
      <ExplorerGridBox />
    </>
  );
};

export default Research;
